// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CreditCardOutline from '../_raw/service/icon_credit_card_outline.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CreditCardOutline);
